/* eslint-disable no-unused-vars */
import { Grid, CircularProgress } from "@mui/material";
import PCalendarDateSelector from "../../components/pos/PCalendarDateSelector";
import PCheck from "../../components/pos/PCheck";
import PConfirm from "../../components/pos/PConfirm";
import PDatePicker from "../../components/pos/PDatePicker";
import PDialog from "../../components/pos/PDialog";
import PSelect from "../../components/pos/PSelect";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import API from "../../utils/API";
import { StringUtils } from "../../utils/StringUtils";
import { SyncUtils } from "../../utils/SyncUtils";

export default function PromotionCrud(props) {
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [offerQty, setOfferQty] = useState(null);
  const [offerQtyError, setofferQtyError] = useState(null);
  const [purchaseQty, setPurchaseQty] = useState(null);
  const [purchaseQtyError, setPurchaseQtyError] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [fromDateError, setFromDateError] = useState(null);
  const [toDate, setToDate] = useState("");
  const [toDateError, setToDateError] = useState(null);
  const [policyModeOptions, setPolicyModeOptions] = useState([]);
  const [policyMode, setPolicyMode] = useState({
    name: "Weekly",
    code: "WEEK",
  });
  const [policyModeError, setPolicyModeError] = useState("");
  const [isMondaySelected, setMondaySelected] = useState(false);
  const [isTuesDaySelected, setTuesDaySelected] = useState(false);
  const [isWednesDaySelected, setWednesDaySelected] = useState(false);
  const [isThursDaySelected, setThursDaySelected] = useState(false);
  const [isFriDaySelected, setFriDaySelected] = useState(false);
  const [isSaturDaySelected, setSaturDaySelected] = useState(false);
  const [isSundaySelected, setSundaySelected] = useState(false);
  const [isAllSelected, setAllSelected] = useState(false);
  const [calenderDate, setCalenderDate] = useState([]);
  const [policyName, setPolicyName] = useState("");
  const [policyNameError, setPolicyNameError] = useState("");
  const [policyRuleType, setPolicyRuleType] = useState({
    name: "Free",
    code: "FREE",
  });
  const [policyRuleTypeError, setPolicyRuleTypeError] = useState("");
  const [groupingPolicy, setGroupingPolicy] = useState({
    name: "Shop Best",
    code: "SHOP",
  });
  const [groupingPolicyError, setGroupingPolicyError] = useState("");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  props.biRef.child = {
    showPromotionCrudWindow: showPromotionCrudWindow,
  };

  useEffect(() => {
    if (origObject) {
      setWindowTitile(origObject.policyName);
    }
  }, [origObject]);

  useEffect(() => {
    setPolicyModeOptions([
      { name: "Weekly", code: "WEEK" },
      { name: "Date Wise", code: "DAY" },
    ]);
    setCalenderDate([
      { value: "1", isSelected: false, index: 0 },
      { value: "2", isSelected: false, index: 1 },
      { value: "3", isSelected: false, index: 2 },
      { value: "4", isSelected: false, index: 3 },
      { value: "5", isSelected: false, index: 4 },
      { value: "6", isSelected: false, index: 5 },
      { value: "7", isSelected: false, index: 6 },
      { value: "8", isSelected: false, index: 7 },
      { value: "9", isSelected: false, index: 8 },
      { value: "10", isSelected: false, index: 9 },
      { value: "11", isSelected: false, index: 10 },
      { value: "12", isSelected: false, index: 11 },
      { value: "13", isSelected: false, index: 12 },
      { value: "14", isSelected: false, index: 13 },
      { value: "15", isSelected: false, index: 14 },
      { value: "16", isSelected: false, index: 15 },
      { value: "17", isSelected: false, index: 16 },
      { value: "18", isSelected: false, index: 17 },
      { value: "19", isSelected: false, index: 18 },
      { value: "20", isSelected: false, index: 19 },
      { value: "21", isSelected: false, index: 20 },
      { value: "22", isSelected: false, index: 21 },
      { value: "23", isSelected: false, index: 22 },
      { value: "24", isSelected: false, index: 23 },
      { value: "25", isSelected: false, index: 24 },
      { value: "26", isSelected: false, index: 25 },
      { value: "27", isSelected: false, index: 26 },
      { value: "28", isSelected: false, index: 27 },
      { value: "29", isSelected: false, index: 28 },
      { value: "30", isSelected: false, index: 29 },
      { value: "31", isSelected: false, index: 30 },
    ]);
  }, []);

  /*Live validation reset*/
  useEffect(() => {
    if (policyName || !policyName === "") setPolicyNameError("");
  }, [policyName]);
  useEffect(() => {
    if (offerQty || !offerQty === "") setofferQtyError("");
  }, [offerQty]);
  useEffect(() => {
    if (purchaseQty || !purchaseQty === "") setPurchaseQtyError("");
  }, [purchaseQty]);
  useEffect(() => {
    if (fromDate || !fromDate === "") setFromDateError("");
  }, [fromDate]);
  useEffect(() => {
    if (toDate || !toDate === "") setToDateError("");
  }, [toDate]);
  useEffect(() => {
    if (policyMode || !policyMode === "") setPolicyModeError("");
  }, [policyMode]);

  function showPromotionCrudWindow(promotionId) {
    if (promotionId == null) {
      resetFields();
      setMode("create");
      setOpenWindow(true);
      setWindowTitile("New Promotion");
    } else {
      setMode(
        props.context.privileges.promotion_edit ||
          props.context.privileges.promotion_delete
          ? "edit"
          : "view"
      );
      populatePromotion(promotionId);
    }
  }
  async function populatePromotion(id) {
    {
      try {
        let { data } = await API.get("/api/v1/promotion/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          "Not able to retrive Promotion data from server"
        );
      }
    }
  }

  function populateData(bean) {
    setPolicyName(bean.policyName);
    setPurchaseQty(bean.ruleConfigList[0].ruleBuyLimit);
    setOfferQty(bean.ruleConfigList[0].ruleGetLimit);
    setFromDate(bean.fromDate);
    setToDate(bean.toDate);
    setPolicyMode(bean.policyMode);
    setPolicyRuleType(bean.ruleConfigList[0].ruleType);
    setGroupingPolicy(bean.groupingPolicy);

    let weekDayCount = 0;
    bean.selectedWeek.map((item) => {
      switch (item) {
        case "SUNDAY":
          setSundaySelected(true);
          weekDayCount++;
          break;
        case "MONDAY":
          setMondaySelected(true);
          weekDayCount++;
          break;
        case "TUESDAY":
          setTuesDaySelected(true);
          weekDayCount++;
          break;
        case "WEDNESDAY":
          setWednesDaySelected(true);
          weekDayCount++;
          break;
        case "THURSDAY":
          setThursDaySelected(true);
          weekDayCount++;
          break;
        case "FRIDAY":
          setFriDaySelected(true);
          weekDayCount++;
          break;
        case "SATURDAY":
          setSaturDaySelected(true);
          weekDayCount++;
          break;
      }
    });

    if (weekDayCount == 7) setAllSelected(true);

    setCalenderDate(bean.selectedDateList);
  }

  function resetFields() {
    clearSelection();
    setPolicyName("");
    setOfferQty("");
    setPurchaseQty("");
    setFromDate("");
    setToDate("");
    setPolicyMode({ name: "Weekly", code: "WEEK" });
    setPolicyNameError("");
    setofferQtyError("");
    setPurchaseQtyError("");
    setFromDateError("");
    setToDateError("");
    setPolicyModeError("");
    setPolicyRuleType({ name: "Free", code: "FREE" });
    setPolicyRuleTypeError("");
    setGroupingPolicy({ name: "Shop Best", code: "SHOP" });
    setGroupingPolicyError("");
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    if (props.context.privileges.promotion_delete) {
      setConfirmOpen(true);
      setConfirmContext({
        title: "Are You Sure",
        message:
          "Are you sure to delete promotion :" + origObject.policyName + " ?",
        type: "warning",
        open: true,
        yes: true,
        no: true,
      });
    } else {
      props.showMessage(
        "error",
        "You dont have any privilege to delete promotion"
      );
    }
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/promotion/" + origObject.id);
        // props.showMessage("warning", "Tax " + name + " got Removed");
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", "Not able to Delete Promotions");
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/promotion", payload);
        props.showMessage("success", "Saved Successfully");
        SyncUtils.requestSync(result.headers);
        props.onRefresh();
        showProgress(false, "Saving");
        setOpenWindow(false);
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", "Not able to Save Promotion");
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
    }
    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    saveObject["policyName"] = policyName;
    saveObject["groupingPolicy"] = groupingPolicy;
    let ruleConfigList = [];
    ruleConfigList.push({
      ruleBuyLimit: purchaseQty,
      ruleGetLimit: offerQty,
      ruleType: policyRuleType,
    });
    saveObject["ruleConfigList"] = ruleConfigList;
    saveObject["fromDate"] = fromDate + "T00:00:00.000Z";
    saveObject["toDate"] = toDate + "T00:00:00.000Z";
    saveObject["policyMode"] = policyMode;
    saveObject["selectedDateList"] = calenderDate;
    saveObject["selectedWeek"] = getSelectedWeekDays();
    return saveObject;
  }

  function getSelectedWeekDays() {
    let weekDays = [];
    if (isMondaySelected) weekDays.push("MONDAY");
    if (isTuesDaySelected) weekDays.push("TUESDAY");
    if (isWednesDaySelected) weekDays.push("WEDNESDAY");
    if (isThursDaySelected) weekDays.push("THURSDAY");
    if (isFriDaySelected) weekDays.push("FRIDAY");
    if (isSaturDaySelected) weekDays.push("SATURDAY");
    if (isSundaySelected) weekDays.push("SUNDAY");

    return weekDays;
  }

  function isAnyDateSelected() {
    for (let dateVal of calenderDate) {
      if (dateVal.isSelected) return true;
    }
    return false;
  }

  function validate() {
    let flag = true;
    if (!policyName || policyName === "") {
      setPolicyNameError("Name is Required");
      flag = false;
    }
    if (
      (!offerQty || offerQty === "") &&
      policyRuleType.code != "PRODUCT_LEVEL_PRICING"
    ) {
      setofferQtyError("Offer QTY is Required");
      flag = false;
    }
    if (!policyRuleType || policyRuleType === "") {
      setPurchaseQtyError("Policy rule type is Required");
      flag = false;
    }
    if (
      (!purchaseQty || purchaseQty === "") &&
      policyRuleType.code != "PRODUCT_LEVEL_PRICING"
    ) {
      setPurchaseQtyError("Purchase QTY is Required");
      flag = false;
    }
    if (!groupingPolicy || groupingPolicy === "") {
      setGroupingPolicyError("Grouping policy is Required");
      flag = false;
    }
    if (!fromDate || fromDate === "") {
      setFromDateError("From date is Required");
      flag = false;
    }
    if (!toDate || toDate === "") {
      setToDateError("To date is Required");
      flag = false;
    }
    if ((fromDate || fromDate != "") && (toDate || toDate != "")) {
      let fromDte = new Date(fromDate).getTime();
      let toDte = new Date(toDate).getTime();
      if (fromDte > toDte) {
        setToDateError("To date value is worng");
        flag = false;
      }
    }
    if (!policyMode || policyMode === "") {
      setPolicyModeError("Policy mode is Required");
      flag = false;
    } else {
      if (policyMode.code == "WEEK") {
        if (
          !isMondaySelected &&
          !isTuesDaySelected &&
          !isWednesDaySelected &&
          !isThursDaySelected &&
          !isFriDaySelected &&
          !isSaturDaySelected &&
          !isSundaySelected
        ) {
          props.showMessage("error", "Atleast one day should be selected");
          flag = false;
        }
      } else if (!isAnyDateSelected()) {
        props.showMessage("error", "Atleast one date should be selected");
        flag = false;
      }
    }

    return flag;
  }

  function clearSelection() {
    let tempCalenderDate = [...calenderDate];
    calenderDate.map((dateObj) => {
      let tempItem = { ...tempCalenderDate[dateObj.index] };
      tempItem.isSelected = false;
      tempCalenderDate[dateObj.index] = tempItem;
    });
    setCalenderDate(tempCalenderDate);
    setMondaySelected(false);
    setTuesDaySelected(false);
    setWednesDaySelected(false);
    setThursDaySelected(false);
    setFriDaySelected(false);
    setSaturDaySelected(false);
    setSundaySelected(false);
    setAllSelected(false);
  }

  function toggleAllSelected() {
    if (
      isMondaySelected &&
      isTuesDaySelected &&
      isWednesDaySelected &&
      isThursDaySelected &&
      isFriDaySelected &&
      isSaturDaySelected &&
      isSundaySelected
    ) {
      setAllSelected(true);
    } else {
      setAllSelected(false);
    }
  }

  const content = (
    <div style={{ paddingLeft: "20px", paddingTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid container spacing={0}>
          <Grid item sm={3} xs={12}>
            <table width="100%">
              <tr>
                <td>Policy Name</td>
              </tr>
            </table>
          </Grid>
          <Grid item sm={9} xs={12}>
            <table width="95%">
              <PText
                value={policyName}
                error={policyNameError}
                onChange={(e) => setPolicyName(e.target.value)}
              ></PText>
            </table>
          </Grid>
        </Grid>

        <Grid container spacing={0}>
          <Grid item sm={3} xs={12}>
            <table width="100%">
              <tr>
                <td>Rule Type</td>
              </tr>
            </table>
          </Grid>
          <Grid item sm={9} xs={12}>
            <table width="95%">
              <PSelect
                options={[
                  { name: "Free", code: "FREE" },
                  { name: "Percentage", code: "PERCENTAGE" },
                  {
                    name: "Product Level Pricing",
                    code: "PRODUCT_LEVEL_PRICING",
                  },
                ]}
                value={policyRuleType}
                errorMessage={policyRuleTypeError}
                onChange={(event, newValue) => {
                  setPolicyRuleType(newValue);
                }}
              ></PSelect>
            </table>
          </Grid>
        </Grid>

        <Grid container spacing={0}>
          <Grid item sm={3} xs={12}>
            <table width="100%">
              <tr>
                {policyRuleType.code == "PRODUCT_LEVEL_PRICING" ? (
                  true && (
                    <td style={{ paddingTop: 6, color: "#c9d1cb" }}>
                      Policy Rule
                    </td>
                  )
                ) : (
                  <td style={{ paddingTop: 6 }}>Policy Rule</td>
                )}
              </tr>
            </table>
          </Grid>
          <Grid item sm={9} xs={12}>
            <table width="95%">
              <tr>
                <td>
                  <table>
                    <tr>
                      {policyRuleType.code == "PRODUCT_LEVEL_PRICING" ? (
                        true && <td style={{ color: "#c9d1cb" }}>Buy</td>
                      ) : (
                        <td>Buy</td>
                      )}
                      <td>
                        <PText
                          type="number"
                          value={purchaseQty}
                          error={purchaseQtyError}
                          disabled={
                            policyRuleType.code == "PRODUCT_LEVEL_PRICING"
                              ? true
                              : false
                          }
                          onChange={(e) => setPurchaseQty(e.target.value)}
                        ></PText>
                      </td>
                      {policyRuleType.code == "PRODUCT_LEVEL_PRICING" ? (
                        true && <td style={{ color: "#c9d1cb" }}>Get</td>
                      ) : (
                        <td>Get</td>
                      )}
                      <td style={{ width: "40%" }}>
                        <PText
                          type="number"
                          value={offerQty}
                          error={offerQtyError}
                          step={0.01}
                          disabled={
                            policyRuleType.code == "PRODUCT_LEVEL_PRICING"
                              ? true
                              : false
                          }
                          onChange={(e) => setOfferQty(e.target.value)}
                        ></PText>
                      </td>
                      {policyRuleType.code === "PRODUCT_LEVEL_PRICING" ? (
                        false
                      ) : true && policyRuleType.code === "FREE" ? (
                        <td style={{ paddingLeft: 5 }}>No</td>
                      ) : (
                        <td style={{ paddingLeft: 5 }}>%</td>
                      )}
                      {}
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </Grid>
        </Grid>

        <Grid container spacing={0}>
          <Grid item sm={3} xs={12}>
            <table width="100%">
              <tr>
                <td
                  style={{
                    paddingTop: 3,
                    paddingBottom: 7,
                    fontWeight: "bold",
                  }}
                >
                  Grouping Policy
                </td>
              </tr>
            </table>
          </Grid>
          {/*<Grid item sm={9} xs={12}>
            <table width="95%">
              <PSelect
                options={[
                  { name: "Customer Best", code: "CUSTOMER" },
                  { name: "Shop Best", code: "SHOP" },
                ]}
                value={groupingPolicy}
                errorMessage={groupingPolicyError}
                onChange={(event, newValue) => {
                  setGroupingPolicy(newValue);
                }}
              ></PSelect>
            </table>
              </Grid>*/}
        </Grid>
        <Grid container spacing={0}>
          <Grid item sm={3} xs={12}>
            <table width="100%">
              <tr>
                <td>Policy Date</td>
              </tr>
            </table>
          </Grid>
          <Grid item sm={9} xs={12}>
            <table width="95%">
              <table>
                <tr>
                  <td>From</td>
                  <td>
                    <PDatePicker
                      value={fromDate}
                      error={fromDateError}
                      onChange={(value) =>
                        setFromDate(StringUtils.formatDate(value.$d, 2))
                      }
                    ></PDatePicker>
                  </td>
                  <td>To</td>
                  <td>
                    <PDatePicker
                      value={toDate}
                      error={toDateError}
                      onChange={(value) =>
                        setToDate(StringUtils.formatDate(value.$d, 2))
                      }
                    ></PDatePicker>
                  </td>
                </tr>
              </table>
            </table>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item sm={3} xs={12}>
            <table width="100%">
              <tr>
                <td>Policy Mode</td>
              </tr>
            </table>
          </Grid>
          <Grid item sm={9} xs={12}>
            <table width="95%">
              <PSelect
                options={policyModeOptions}
                value={policyMode}
                errorMessage={policyModeError}
                onChange={(event, newValue) => {
                  setPolicyMode(newValue);
                  clearSelection();
                }}
              ></PSelect>
            </table>
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item sm={3} xs={12}>
            <table width="100%">
              <tr>
                <td>Policy Day</td>
              </tr>
            </table>
          </Grid>
          <Grid item sm={9} xs={12}>
            <table width="95%">
              {policyMode.code == "WEEK" ? (
                <table>
                  <tr>
                    <td>
                      <PCheck
                        onChange={(value) => {
                          setMondaySelected(value);
                          setTuesDaySelected(value);
                          setWednesDaySelected(value);
                          setThursDaySelected(value);
                          setFriDaySelected(value);
                          setSaturDaySelected(value);
                          setSundaySelected(value);
                          setAllSelected(value);
                        }}
                        checked={isAllSelected}
                        label="All"
                      ></PCheck>
                    </td>
                    <td>
                      <PCheck
                        onChange={(value) => {
                          setSundaySelected(value);
                          toggleAllSelected();
                        }}
                        checked={isSundaySelected}
                        label="Sunday"
                      ></PCheck>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <PCheck
                        onChange={(value) => {
                          setMondaySelected(value);
                          toggleAllSelected();
                        }}
                        checked={isMondaySelected}
                        label="Monday"
                      ></PCheck>
                    </td>
                    <td>
                      <PCheck
                        onChange={(value) => {
                          setTuesDaySelected(value);
                          toggleAllSelected();
                        }}
                        checked={isTuesDaySelected}
                        label="Tuesday"
                      ></PCheck>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <PCheck
                        onChange={(value) => {
                          setWednesDaySelected(value);
                          toggleAllSelected();
                        }}
                        checked={isWednesDaySelected}
                        label="Wednesday"
                      ></PCheck>
                    </td>
                    <td>
                      <PCheck
                        onChange={(value) => {
                          setThursDaySelected(value);
                          toggleAllSelected();
                        }}
                        checked={isThursDaySelected}
                        label="Thursday"
                      ></PCheck>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <PCheck
                        onChange={(value) => {
                          setFriDaySelected(value);
                          toggleAllSelected();
                        }}
                        checked={isFriDaySelected}
                        label="Friday"
                      ></PCheck>
                    </td>
                    <td>
                      <PCheck
                        onChange={(value) => {
                          setSaturDaySelected(value);
                          toggleAllSelected();
                        }}
                        checked={isSaturDaySelected}
                        label="Saturday"
                      ></PCheck>
                    </td>
                  </tr>
                </table>
              ) : (
                <PCalendarDateSelector
                  setCalenderDate={setCalenderDate}
                  calenderDate={calenderDate}
                ></PCalendarDateSelector>
              )}
            </table>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          hideSave={
            (!props.context.privileges.promotion_edit &&
              props.context.privileges.promotion_delete) ||
            mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
